import { render, staticRenderFns } from "./FlushingDetail.vue?vue&type=template&id=3087da9a"
import script from "./FlushingDetail.vue?vue&type=script&lang=js"
export * from "./FlushingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports